import { init as initLookbookVideoSection } from "../sections/lookbook-video";
import { init as initLookbookSectionV4 } from "../sections/lookbook-v4";

/* should go through all the sections available on page template
and for lookbook only to lookbook sections */
export function init() {
  const lookbookSection = document.querySelector(".shopify-section.lookbook");
  if (lookbookSection instanceof HTMLElement) {
    initLookbookSectionV4();
  }
  const lookbookVideoSection = document.querySelector(
    ".shopify-section.lookbook-video"
  );
  if (lookbookVideoSection instanceof HTMLElement) {
    initLookbookVideoSection(lookbookVideoSection);
  }
}
